module.exports = __webpack_public_path__ + "static/media/spinner-dec.dbd81b41.svg";